import React, { FC } from 'react';
import { resolveLocalizedText } from '../../helpers/resolveLocalizedText';
import { setLang } from '../../helpers/setLang';
import { useTranslation } from 'react-i18next';
import { analytics } from '../../helpers/analytics';
import { RESULT_CLICKED } from '../../helpers/analytics/constants';


interface AlternativeBookingOptionProps {
	href: string;
	label: string;
	selfLabel: string;
	selfPosition: 'left' | 'right';
}

const AlternativeBookingOptions: FC<AlternativeBookingOptionProps> = ({ href, label, selfLabel, selfPosition }) => {
	const { i18n } = useTranslation();
	const lang = i18n.language;

	let localizedHref = href;
	if (lang !== 'en') {
		localizedHref = setLang(href, lang);
	}

	const activeOption =
		<div className='py-3 px-4 rounded-2xl grow bg-tablz-med-gray-6'>
			<span className='text-tablz-text-gray-2 font-poppins text-lg font-semibold'>{resolveLocalizedText(selfLabel, lang)}</span>
		</div>;

	const inactiveOption =
		<a
			href={localizedHref}
			target='_self'
			rel='noreferrer'
			aria-label={resolveLocalizedText(label, lang)}
			className='py-3 px-4 rounded-2xl grow hover:bg-tablz-med-gray-6'
			onClick={() => analytics.track(RESULT_CLICKED, { resultType: 'direct link' })}
		>
			<div className='text-tablz-text-gray-2 font-poppins text-lg font-semibold'>
				<span>{resolveLocalizedText(label, lang)}</span>
			</div>
		</a>;


	return (
		<div className="mt-6 w-full flex rounded-2xl p-1 gap-1 border border-tablz-med-gray-4 bg-tablz-med-gray-1 justify-between h-fit">
			{selfPosition === 'left' ? activeOption : inactiveOption}
			{selfPosition === 'left' ? inactiveOption : activeOption}
		</div>
	);
};

export default AlternativeBookingOptions;
